import { createTheme } from '@mui/material/styles';

// Needed for theme to work with TS
// https://mui.com/material-ui/customization/theming/#custom-variables

declare module '@mui/material/styles' {
  interface Theme {
    brandcolor: {
      primaryLight: string;
      primary: string;
      primaryDark: string;
      success: string;
      error: string;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    brandcolor?: {
      primaryLight?: string;
      primary?: string;
      primaryDark?: string;
      success?: string;
      error?: string;
    };
  }
  interface Palette {
    black: Palette['primary'];
  }

  interface PaletteOptions {
    black: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    black: true;
  }
}

const theme = createTheme({
  brandcolor: {
    primaryLight: 'hsl(200, 100%, 91%)',
    primary: 'hsl(200, 100%, 50%)',
    primaryDark: 'hsl(200, 100%, 6%)',
    success: 'hsl(100, 60%, 50%)',
    error: 'hsl(0, 60%, 50%)',
  },
  palette: {
    black: {
      main: '#000',
      contrastText: '#fff',
    },
  },
  spacing: [0, 4, 8, 16, 32, 64],
});

export default theme;
